var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnnotated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "#e6e7e8",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1C6.486 1 2 5.486 2 11c0 4.936 3.656 9.026 8.437 9.876L12 23l1.563-2.124C18.344 20.026 22 15.936 22 11 22 5.486 17.514 1 12 1zm0 2c4.411 0 8 3.589 8 8 0 3.982-3.021 7.432-6.938 7.938L12 20.587l-1.062-1.648C7.021 18.432 4 14.982 4 11c0-4.411 3.589-8 8-8zm0 3c-.552 0-1 .448-1 1v4c0 .552.448 1 1 1s1-.448 1-1v-4c0-.552-.448-1-1-1zm0 8a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnotated);
export default __webpack_public_path__ + "static/media/annotated.8621085282866ce7aa8833bfa8eaeb43.svg";
export { ForwardRef as ReactComponent };